import getDay from "date-fns/getDay";

export default date => {
    var dayOfTheWeek = getDay(date);
    switch(dayOfTheWeek)
    {
        case 1: return "ponedjeljak";
        case 2: return "utorak";
        case 3: return "srijeda";
        case 4: return "četvrtak";
        case 5: return "petak";
        case 6: return "subota";
        case 0: return "nedjelja";
        default: return "-";
    }
};


// WEBPACK FOOTER //
// ./src/common/filters/date/day.filter.js